import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IRequestPreCadastroRenovacaoCnh } from './types';

// ACTIONS
import {
	confirmaPreCadastroRenovacaoSuccess,
	confirmaPreCadastroRenovacaoFailure,
} from './actions';

function* confirmaPreCadastroRenovacao(request: ReducerAction) {
	const { payload }: { payload: IRequestPreCadastroRenovacaoCnh } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`confirma/${CHANNEL}/confirmaPreCadastroRenovacao`,
		payload,
	);

	if (response.status === 200) {
		yield put(confirmaPreCadastroRenovacaoSuccess(response));
	} else if (response.error) {
		yield put(confirmaPreCadastroRenovacaoFailure(response.error));
	}
}

export default all([
	takeLatest(
		Types.CONFIRMA_PRE_CADASTRO_RENOVACAO,
		confirmaPreCadastroRenovacao,
	),
]);
